/**
 * Chat API Error Helpers
 *
 * Normalize error payloads returned by chat API routes.
 *
 * Primary responsibilities:
 * - Read `message` or `error` fields from API payloads
 * - Provide a safe fallback when payloads are empty or malformed
 *
 * Dependencies:
 * - None
 */

export function readChatApiErrorMessage(
  payload: unknown,
  fallback: string
) {
  if (!payload || typeof payload !== 'object') {
    return fallback
  }

  if (typeof payload.message === 'string' && payload.message.trim()) {
    return payload.message
  }

  if (typeof payload.error === 'string' && payload.error.trim()) {
    return payload.error
  }

  return fallback
}
